var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.iosPayTipShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "iosPayTip" } }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\r\n                " +
                _vm._s(_vm.$t("language.popup.iosPayTipPopup.title")) +
                "\r\n            "
            ),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  _vm.iosPayTipShow = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ios-tip-body" }, [
            _c("div", { staticClass: "ios-tip-mid" }, [
              _c("div", { staticClass: "ios-tip-tips" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("language.popup.iosPayTipPopup.tip", {
                      name: _vm.payInfo.name,
                      id: _vm.payInfo.appleId
                    })
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ios-tip-close" }, [
              _c(
                "button",
                {
                  staticClass: "white-btn",
                  on: {
                    click: function($event) {
                      return _vm.unsubscribePlan()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.popup.iosPayTipPopup.btnTxt")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      _vm.iosPayTipShow = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7eb556d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb556d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/pay_system_popups/ios_pay_tip_popups.vue
// module id = null
// module chunks = 